/* tslint:disable:indent */
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationMessages } from 'src/app/modules/shared/models/component-messages/validation-messages';
import { FormsMapper } from '../../../../../models/enums/forms.enum';
import { InformationComponent } from '../../../../shared/modals/information/information.component';
import { CompatibiliteMessage } from '../../../../shared/models/component-messages/compatibilite/compatibilite';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-stepper-valider-elements',
  templateUrl: './valider-elements.component.html'
})
export class ValiderElementsComponent implements OnInit {

  public validerMessage = new ValidationMessages();
  @Input() form: FormGroup;
  @Input() formulaireIntitule: string;
  @Input() element = true;
  @Input() indexPage;
  public compatibiliteMessage = new CompatibiliteMessage();

  constructor(public canNavigateInStepper: CanNavigateInStepperService,
    private modalService: NgbModal, private translateService: TranslateService) {
  }

  public ngOnInit() {
    const intitule = FormsMapper.getIntitule(this.canNavigateInStepper.currentFormulaire)?.toString().includes("eform") ? this.translateService.instant(FormsMapper.getIntitule(this.canNavigateInStepper.currentFormulaire)) : FormsMapper.getIntitule(this.canNavigateInStepper.currentFormulaire)
    !this.form.controls.formIntitule.value ?
      this.form.controls.formIntitule.setValue(intitule)
      : this.form.controls.formIntitule.setValue('');
  }

  openModal() {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    if (this.indexPage === 3) {
      modalRef.componentInstance.content = this.compatibiliteMessage.M013;
    } else {
      modalRef.componentInstance.content = this.compatibiliteMessage.M016;
    }
  }

}
